/**
 * Get content session from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

export const homeGQLQuery = () => {
  const profilePhotoSize = getIsLowBandwidth() ? 70 : 140
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`{
    RootsTechPageEntry(id: "/rootstech-connect-2021-home") {
      ... on OneOffPage {
        name
        content(site: "") {
          ... on MainStageModule {
            ctaText
            eyebrow
            video {
              videoId
              provider
            }
            title
            calendar {
              date {
                timestamp
              }
              item {
                objectTypeId
                title
                type
                category
                url
                creators {
                  profilePhoto {
                    custom(height: ${profilePhotoSize}, width: ${profilePhotoSize}) {
                      image {
                        src
                        }
                      }
                  }
                  name
                }
              }
            }
          }
          ... on Promo {
            _viewTemplate
            category
            title
            url
            type
            objectTypeId
          }
          ... on ListModule {
            _viewTemplate
            ctaTarget
            ctaText
            ctaLabel
            ctaUrl
            title
            description
            items {
              objectTypeId
              title
              description
              url
              type
              image {
                custom(height: ${imageSize}, width: ${imageSize}) {
                  image {
                    src
                  }
                }
              }
              creators {
                name
                profilePhoto {
                  custom(height: ${imageSize}, width: ${imageSize}) {
                    image {
                      src
                      }
                    }
                }
              }
            }

          }
        }
      }
    }
}
  `)
}

export const homePreGQLQuery = () => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`
  {
    RootsTechPageEntry(path: "/home-pre") {
      ... on OneOffPage {
        name
        content {
          ... on ListModule {
            title
            description
            items {
              description
              duration
              title
              url
              creators {
                profilePhoto {
                  custom(height: ${imageSize}, width: ${imageSize}) {
                    image {
                      src
                      }
                    }
                }
              }
            }
          }
        }
      }
    }
}
  `)
}

export const previewLookupGQLQuery = (previewId) => {
  return gql(`
  {
    RootsTechPageEntry( id: "${previewId}") {
      __typename
    }
  }
`)
}
